import type { Editor, JSONContent } from '@tiptap/react';

import { attachFile } from './attachments';

// A bare domain is a relative address once it reaches ClickUp; anything that
// already names a scheme (https:, mailto:) is left as written.
export function withProtocol(url: string): string {
  return /^[a-z][a-z0-9+.-]*:/i.test(url) ? url : `https://${url}`;
}

// HEIC is a photo the browser cannot draw, so it goes in as a file to open.
const DRAWABLE = new Set(['image/png', 'image/jpeg', 'image/gif', 'image/webp']);

// Images show where they were put; anything else is a link by its name, with a
// space after it so the next word is not part of the link.
export function insertAttachments(editor: Editor, files: File[]): void {
  const content = files.flatMap((file): JSONContent[] => {
    const url = attachFile(file);
    return DRAWABLE.has(file.type)
      ? [{ type: 'image', attrs: { src: url, alt: file.name } }]
      : [
          { type: 'text', text: file.name, marks: [{ type: 'link', attrs: { href: url } }] },
          { type: 'text', text: ' ' },
        ];
  });
  editor.chain().focus().insertContent(content).run();
}
